import { useEffect, useState, useRef, useMemo } from "react";
import Image from "next/legacy/image";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { NoSsr, Typography, useMediaQuery } from "@mui/material";
import logo from "@public/logo.webp";
import reviewAnimation from "@public/assets/Lottie/review.json";
import playStoreImage from "../../../../public/assets/onboardingImages/playStoreImage1.png";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import style from "../../styles/pujaReviews.module.css";
import dynamic from "next/dynamic";
import ReviewCard from "./ReviewPuja";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import { useRouter } from "next/router";
import "video-react/dist/video-react.css";
import quotePic from "@public/assets/newEvent/quoteLeft.png";
import LiteYouTubeEmbed from "react-lite-youtube-embed";
import "react-lite-youtube-embed/dist/LiteYouTubeEmbed.css";
import theme from "src/globalModule/styles/theme";
import { LANGUAGE } from "@utils/constants";
import { getRandomReviews } from "@utils/pujaReviews";
const Lottie = dynamic(() => import("lottie-react"), {
  ssr: false
});
const PujaReviews = ({
  kriya_name,
  name_WE
}) => {
  // Memoize the random reviews so it's calculated only once on mount
  const memoizedReviews = useMemo(() => getRandomReviews(), []);
  const [reviews] = useState(memoizedReviews); // Initialize state with memoized value

  const {
    t
  } = useTranslation();
  const router = useRouter();
  const smallScreen = useMediaQuery("(max-width: 768px)");
  const [mOpen, setMOpen] = useState(false);
  const sliderRef = useRef();
  const [hydrated, setHydrated] = useState(false);
  const playerRef = useRef();
  useEffect(() => {
    setHydrated(true);
  }, []);
  if (!hydrated) {
    return null;
  }
  function ModelOpen() {
    return <Modal open={mOpen} onClose={() => setMOpen(false)} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description" data-sentry-element="Modal" data-sentry-component="ModelOpen" data-sentry-source-file="PujaReviews.jsx">
        <Box sx={{
        boxShadow: 24
      }} className={style.mModal1} data-sentry-element="Box" data-sentry-source-file="PujaReviews.jsx">
          <div className={style.mBody}>
            <p className={style.mBodyHead}>
              {t("to-see-all-reviews-given-by-every-devotee-who-has-offered-this-puja")}
            </p>
            <p className={style.mBodyHead1}>{t("download-utsav-app-now")}</p>
            <Lottie animationData={reviewAnimation} loop={true} className={style.mBodyAnimation} data-sentry-element="Lottie" data-sentry-source-file="PujaReviews.jsx" />

            <div className={style.donationItems}>
              <div className={style.donationHeading}>
                <div className={style.form_logo}>
                  <Image src={logo} alt={t("utsav-logo")} priority data-sentry-element="Image" data-sentry-source-file="PujaReviews.jsx" />
                </div>
                <div className={style.form_name}>
                  <p className={style.form_logo_name}>{t("utsav")}</p>
                </div>
              </div>
              <div className={style.section1_download}>
                <Link href="https://play.google.com/store/apps/details?id=com.applex.utsav" className={style.section1_download_link} target="blank" rel="alternate" hrefLang={router.locale} data-sentry-element="Link" data-sentry-source-file="PujaReviews.jsx">
                  <Image src={playStoreImage} alt="Utsav Playstore Donwload Image" className={style.section1_download_link_img} data-sentry-element="Image" data-sentry-source-file="PujaReviews.jsx" />
                </Link>
              </div>
            </div>
          </div>
        </Box>
      </Modal>;
  }
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    arrows: false,
    dots: true,
    slidesToScroll: 1,
    draggable: false
  };
  return <>
      {smallScreen ? <div className={style.reviewCardContainer}>
          <div className={style.reviewCard}>
            <Typography fontFamily={"Poppins"} fontSize={"20px"} fontWeight={"bold"} color={theme.palette.text.primary}>
              {t("What")}
              <span style={{
            color: "#FF8F0B"
          }}>{t("devotees-0")}</span>
              {t("say-about-utsav")}
            </Typography>

            <Typography fontSize={"16px"} mt={"5px"}>
              {t("9-10-devotees-rate-utsav-5")}
            </Typography>
          </div>

          {/* <ReactPlayer
              ref={playerRef}
              url={"https://youtu.be/Z2FfFFC0YyM"}
              controls={true}
              height={"100%"}
              width={"100%"}
            /> */}

          {/* TO BE ENABLED ONCE YOUTUBE REDIRECTION IS STOPPED
           <div className={style.videoContainer}>
                  <LiteYouTubeEmbed
              id="Z2FfFFC0YyM"
              title="Utsav Puja Review Video"
            />
           </div> */}

          {/* <div className={style.videoContainer}>
            <LiteYouTubeEmbed
              id={
                router.locale === LANGUAGE.ENGLISH
                  ? "38rBI3t1VaA"
                  : "1Kvrhq0-4_I"
              }
              title="Utsav Puja Review Video"
            />
           </div> */}

          <div className={style.reviewContainerSm}>
            <div>
              <Image src={quotePic} alt="quote" width="40" height="40" />
            </div>
            <div className={style.reviewCarouselContainer}>
              {/* <Slider ref={sliderRef} {...settings}> */}
              {reviews.length >= 5 && reviews.slice(0, 8).map((review, index) => {
            if (review.review != null && review.review != "") return (
              // <div key={index.toString()} className={style.item}>
              <ReviewCard key={index.toString()} data={review} kriya_name={kriya_name} screen_name={"Kriya Details"} name_WE={name_WE} />
              // </div>
            );
          })}
              {/* </Slider> */}

              {/* <div className={style.navigationArrows}>
                <div className={style.navigationArrowsLi}>
                  <NoSsr>
                    <ArrowBackIosNewOutlinedIcon
                      onClick={() => {
                        sliderRef.current.slickPrev();
                      }}
                      className={style.Icons}
                    />
                  </NoSsr>
                </div>
                <div className={style.navigationArrowsLi}>
                  <NoSsr>
                    <ArrowForwardIosOutlinedIcon
                      onClick={() => {
                        sliderRef.current.slickNext();
                      }}
                      className={`${style.Icons} ${style.IconAct}`}
                    />
                  </NoSsr>
                </div>
               </div> */}
            </div>
          </div>

          {/* <ModelOpen /> */}
        </div> :
    // BigScreen
    <>
          <div className={style.featureTabs}>
            <div className={style.videoContainer}>
              <LiteYouTubeEmbed id={router.locale === LANGUAGE.ENGLISH ? "38rBI3t1VaA" : "1Kvrhq0-4_I"} title="Utsav Puja Review Video" />
            </div>

            <div className={style.reviewContainer}>
              <div className={style.reviewCard}>
                <Typography>{"9/10 Devotees rate Utsav 5 ⭐ "}</Typography>
                <Typography fontSize={"24px"} fontFamily={"Poppins"} fontWeight={"bold"} color={theme.palette.text.primary} mt={"0px"} mb={"10px"}>
                  {"What "}
                  <span style={{
                color: "#FF8F0B"
              }}>Devotees</span>
                  {" say about Utsav"}
                </Typography>
                <div>
                  <Image src={quotePic} alt="quote" width="30" height="30" />
                </div>
              </div>

              <div className={style.reviewCarouselContainer}>
                {/* <div className={style.carouselContainer}> */}
                {/* <Slider ref={sliderRef} {...settings}> */}
                {reviews.length >= 5 && reviews.map((review, index) => {
              if (review.review != null && review.review != "") return (
                // <div key={index.toString()} className={style.item}>
                <ReviewCard key={index.toString()} data={review} kriya_name={kriya_name} screen_name={"Kriya Details"} name_WE={name_WE} />
                // </div>
              );
            })}
                {/* </Slider> */}
              </div>

              {/* <div className={style.navigationArrows}>
                <div className={style.navigationArrowsLi}>
                  <NoSsr>
                    <ArrowBackIosNewOutlinedIcon
                      onClick={() => {
                        sliderRef.current.slickPrev();
                      }}
                      className={style.Icons}
                    />
                  </NoSsr>
                </div>
                <div className={style.navigationArrowsLi}>
                  <NoSsr>
                    <ArrowForwardIosOutlinedIcon
                      onClick={() => {
                        sliderRef.current.slickNext();
                      }}
                      className={`${style.Icons} ${style.IconAct}`}
                    />
                  </NoSsr>
                </div>
               </div> */}
            </div>
          </div>

          <ModelOpen />
        </>}
    </>;
};
export default PujaReviews;